import { render } from "./CardPolicy.vue?vue&type=template&id=66d49cf0&scoped=true"
import script from "./CardPolicy.vue?vue&type=script&lang=js"
export * from "./CardPolicy.vue?vue&type=script&lang=js"

import "./CardPolicy.vue?vue&type=style&index=0&id=66d49cf0&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d49cf0"]])

export default __exports__